<template>
  <div class="liveBroadcast">{{msg}}</div>
</template>
<script>
export default {
  data(){
    return {
      msg: '这是直播页面'
    }
  }
}
</script>
<style lang="scss" scoped>
.liveBroadcast{position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: #fff; z-index: 99;}
</style>